'use strict';

module.exports = require('ck-core/source/functions/makeLang')({
	TITLE: 'An Error Occurred',
	MESSAGE: '$message Please try again and contact support if this persists.'
});
